import { controls } from "../../controls";

const hs301 = {
  label: "Share Transaction Correction",
  pageLabel: "Share Transaction Correction",
  starting: true,
  url: "hs301",
  //bulk: { columns: ["account_number", "balance", "odamt", "d1_class", "d2_class", "d3_class", "l_a_class60", "new_od_60", "no_mrg_6"] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.displayText({ tab: "filter", star: true, label: "Date From-To", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "-", width: "col-sm-0 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "member_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "Member Number", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", star: true, label: "Transaction Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "trn_action", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Issue",
        value: "issue"
      },
      {
        label: "By Transfer (Issue)",
        value: "by_transfer"
      },
      {
        label: "To Transfer",
        value: "to_transfer"
      },
      {
        label: "Withdraw",
        value: "withdraw"
      },
      {
        label: "Cancel",
        value: "cancel"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "Certificate Number", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "certificate_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "Transaction Number", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "transaction_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "Amount Range", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_from", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "-", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_to", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),
  ],


  form: [

    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ width: "col-sm-4" }),

    ...controls.magicDateLabel({ label: "Transaction Date", star: true, width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: false, isRequired: true, name: "trn_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ width: "col-sm-8" }),

    ...controls.displayText({ label: "Transaction Number", width: "col-sm-2" }),
    ...controls.showData({ data: "trn_no", name: "trn_no", width: "col-sm-2" }),

    ...controls.displayText({ width: "col-sm-8" }),

    ...controls.displayText({ star: true, label: "Transation Type", width: "col-sm-2" }),
    ...controls.select({
      name: "trn_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Issue",
        value: "issue"
      },
      {
        label: "By Transfer (Issue)",
        value: "by_transfer"
      },
      {
        label: "To Transfer",
        value: "to_transfer"
      },
      {
        label: "Withdraw",
        value: "withdraw"
      },
      {
        label: "Cancel",
        value: "cancel"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      name: "member_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ label: "Member No", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "member_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ label: "Resolution No", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "resolution_number", width: "col-sm-2" }),

    // ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.magicDateLabel({ label: "Resolution Date", width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: false, name: "resolution_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),


    ...controls.displayText({ label: "Certificate No", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "certificate_number", width: "col-sm-2" }),

    //...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.magicDateLabel({ label: "Certificate Date", width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: false, name: "certificate_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.displayText({ label: "No. of Shares", star: true, width: "col-sm-2" }),
    ...controls.numberOnly({ name: "number_of_shares", isRequired: true, width: "col-sm-2" }),

    // ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),


    ...controls.displayText({ label: "Share Value", star: false, width: "col-sm-2" }),
    ...controls.numberOnly({ name: "share_value", isRequired: false, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),

    ...controls.displayText({ label: "Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "amount", width: "col-sm-2" }),

    ...controls.displayText({ label: "Serial Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "serial_number_from", width: "col-sm-2" }),

    ...controls.displayText({ label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ name: "serial_number_to", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ label: "Particulars", width: "col-sm-2" }),
    ...controls.text({ name: "particulars", width: "col-sm-4", placeHolder: "Particulars" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),

    ...controls.displayText({ label: "Trf to Member Type", width: "col-sm-2" }),
    ...controls.select({
      name: "trf_member_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ label: "Trf to Member No", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "trf_member_number", width: "col-sm-2" }),



  ],
  history: {
    perPage: 10,
    reportHeader: "Share Transaction Correction",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Date",
        accessor: "date",
        type: "date"
      },
      {
        Header: "Trn. No.",
        accessor: "transaction_number"
      },
      {
        Header: "Trn Type",
        accessor: "transaction_type"
      },
      {
        Header: "Nos",
        accessor: "number_of"
      },
      {
        Header: "Amount",
        accessor: "amount",
        type: "currency"
      },
      {
        Header: "Cert No",
        accessor: "certificate_number"
      },
      {
        Header: "No. From",
        accessor: "number_from"
      },
      {
        Header: "No. To",
        accessor: "number_to"
      },
      {
        Header: "Member No.",
        accessor: "member_number"
      },
      {
        Header: "Particulars",
        accessor: "particulars"
      },
      {
        Header: "Trf To",
        accessor: "trf_to"
      }
    ]
  }
};

export default hs301;